import { render, staticRenderFns } from "./DodAddCustomerAndEmployee.vue?vue&type=template&id=5a6d8325&scoped=true&"
import script from "./DodAddCustomerAndEmployee.vue?vue&type=script&lang=js&"
export * from "./DodAddCustomerAndEmployee.vue?vue&type=script&lang=js&"
import style0 from "./DodAddCustomerAndEmployee.vue?vue&type=style&index=0&id=5a6d8325&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6d8325",
  null
  
)

export default component.exports